/** @jsxImportSource @emotion/react */
import { useTranslation } from "react-i18next";
import { MyText } from "../text/MyText";
import { mobileCss } from "../../util/isMobile";
import { withMyTheme } from "../../theme/theme";
import { css } from "@emotion/react";
import { Phone } from "@mui/icons-material";

export const PHONE_NUMBER = '+48 665 123 549';

const PhoneNumberStyle = withMyTheme((theme) => css`
    font-size: 1.2rem;
    color: ${theme.palette.text.primary};
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    
    &:hover {
        color: ${theme.palette.primary.main};
    }
    
    ${mobileCss(`
        font-size: 1.1rem;
        justify-content: center;
    `)}
`)

const PhoneIconStyle = withMyTheme((theme) => css`
    color: ${theme.palette.primary.main};
    margin-right: 1rem;
    font-size: 1.5rem;
`)

const PhoneTextStyle = withMyTheme((theme) => css`
    font-size: inherit;
`)

interface Props {
    phoneNumber: string;
    withIcon?: boolean;
}

export const PhoneNumber = ({ phoneNumber, withIcon = false }: Props) => {
    const { t } = useTranslation();

    const callNumber = () => {
        window.location.href = `tel:${phoneNumber}`;
    };

    return (
        <div onClick={callNumber} css={PhoneNumberStyle}>
            {withIcon && <Phone css={PhoneIconStyle} />}
            <MyText text={phoneNumber} additionalCss={PhoneTextStyle} />
        </div>
    );
}